// extracted by mini-css-extract-plugin
export default {"ShipmentsLayout":"ShipmentsLayout-styles__ShipmentsLayout__dW0Mj","ShipmentsLayout__Container":"ShipmentsLayout-styles__ShipmentsLayout__Container__zCdYS"};